<template>
    <el-tiptap
        ref="miEditor"
        :content="contentForEditor"
        :extensions="extensions"
        output="json"
        lang="es"
        @onUpdate="onEditorUpdate"
        :tooltip="true"
        :readonly="readMode"
        :show-menubar="!readMode"
        :char-counter-count="!readMode"
        :class="`${readMode ? 'hide-border' : ''}`"
    />

</template>
<script>
import {
    Doc, Paragraph, Text,
    Heading,
    Bold,
    Italic,
    Underline,
    Strike,
    Code,
    CodeBlock,
    Blockquote,
    Link,
    Image,
    BulletList, OrderedList, ListItem,
    TodoList, TodoItem,
    Table, TableHeader, TableRow, TableCell,
    TextAlign,
    LineHeight,
    Indent,
    HorizontalRule,
    History,
    TextColor, TextHighlight,
    FormatClear,
    FontType, FontSize,
    Print, SelectAll,
} from 'element-tiptap';
export default {
    props: ['valueInput', 'images_data', 'readMode'],
    model: {
        prop: 'value',
        event: 'valueChange'
    },
    computed: {
        value: {
            get: function() {
                return this.valueInput
            },
            set: function(value) {
                if(value == null)
                    this.$emit('valueChange', "")
                else
                    this.$emit('valueChange', value)
            }
        },
        // requiredCharLabel:{
        //     get: function(){
        //         if(this.label == "" || this.label == undefined)
        //             return "";
        //         const response = this.label + " *";
        //         for (let i = 0; i < (this?.rule?.length??[]); i++) {
        //             if(this.rule[i]("") != true){
        //                 return response;
        //             }
        //         }
        //         return this.label;
        //     }
        // }
    },
    
    data(){
        return{
            modeeel: null,
            contentForEditor:'',
            extensions: [
               
            ],
        }
    },
    created(){
        this.extensions = [
            new Doc(),
            new Text(),
            new Paragraph(),
            new Heading({ level: 5 }),
            new Bold({ bubble: !this.readMode }), // render command-button in bubble menu.
            new Underline({ bubble: !this.readMode, menubar: true }), // render command-button in bubble menu but not in menubar.
            new Italic(),
            new Strike(),
            new ListItem(),
            new BulletList(),
            new OrderedList(),
            new Code(),
            new CodeBlock(),
            new Blockquote(),
            new Link(),
            new TodoList(),
            new TodoItem(),
            new Table({ bubble: !this.readMode }),
            new TableHeader(),
            new TableRow({ bubble: !this.readMode }),
            new TableCell({ bubble: !this.readMode }),
            new TextAlign({bubble: !this.readMode}),
            new LineHeight(),
            new Indent(),
            new HorizontalRule(),
            new History(),
            new TextColor({bubble: !this.readMode}),
            new TextHighlight(),
            new FormatClear(),
            new FontType(),
            new FontSize(),
            new Print(),
            new SelectAll(),
            new Image({
                bubble: false,
                // Esta función se ejecuta automáticamente cuando el usuario selecciona un archivo
                uploadRequest: async (file) => {
                    
                    // 1. Preparar el FormData para enviar el archivo a tu API
                        var formData = new FormData();
                    formData.append("file", file);
                    formData.append("name", 'test');

                    const result = await this.$api.course.uploadImageBodyLesson(formData);
                    console.log(result, "rsulttt")
                    this.$emit('imagesDataChanged', {id:result.data.data.id, url: result.data.data.url})
                    return result.data.data.url
                }
                
            }),
        ]
    },
    mounted(){
        if(this.valueInput != ''){
            this.setEditorContent();
        }
    },

    methods:{
        setEditorContent: function() {
            // 1. Convertimos el string de la base de datos a un Objeto JS real
            // const jsonObjeto = JSON.parse(this.valStringJson);
            
            // 2. Usamos la referencia para inyectar el JSON con formato
            // Ponemos un elvis operator (?.) o un if por si el editor aún no se ha renderizado
            if (this.$refs.miEditor) {
                if (typeof this.valueInput === "string") {
                    // lesson.content = JSON.stringify(lesson.content)
                    this.$refs.miEditor.editor.setContent(JSON.parse(this.valueInput));
                    return;
                }
                this.$refs.miEditor.editor.setContent(this.valueInput);
            }
        },

        onEditorUpdate(outputFromEditor) {
            // Cuando el usuario escribe, aquí recibes el OBJETO JSON puro
            // Puedes guardarlo directamente en tu variable de control
            this.modeeel = outputFromEditor;
            console.log(outputFromEditor)
            this.$emit('valueChange', outputFromEditor)
        }


    }
}
</script>

<style lang="scss">
    .hide-border.el-tiptap-editor .el-tiptap-editor__content { 
        border: none !important; 
        padding-left: 0;
        padding-right: 0;

    }

    .hide-border.el-tiptap-editor img {
    pointer-events: none;
    }
    .hide-border .el-tiptap-editor__menu-bubble--active{
        display: none;
    }
</style>